import React, { Component } from "react";
import PropTypes from "prop-types";
import { COLORS } from "utils/styles";
import IconButton from "components/IconButton";
import Padder from "components/Padder";
import { PHONE } from "utils/constants/ui";
import { unfixBody } from "utils/view";
import { OVERFLOW_TOUCH } from "utils/constants/ui";
import { withRouter } from "next/router";
import { hideOverlay } from "utils/route";

const OFF_OVERLAY_CLASS = "offContent";

const DEFAULT_CLASSES = {
  container: "fixed w-100 top-0 bottom-0 right-0 left-0 z-7",
  overlay: `${OFF_OVERLAY_CLASS} w-100 h-100 relative`,
  content:
    "contentSection fixed absolute-l w-100 w-50-l top-0 right-0 bottom-0 bg-white bw2 b--black-10 shadow-0 overflow-y-scroll overflow-x-hidden",
  action: "fixed pa2 z-5 ba br2 hairline-1 bg-white bg-white--hover"
};

class Overlay extends Component {
  constructor() {
    super();
    this.hideOffContentClick = this.hideOffContentClick.bind(this);
    this._overlayScroll = null;
  }

  /**
   * Reset scroll top when uuid changes
   * - important for mobile so that we dont get a fully scrolled down page
   * - which looks blank when navigating between models
   */
  componentDidUpdate(prevProps) {
    const { uuid: prevUUID, modelUUID: prevModelUUID } = prevProps;
    const { uuid, modelUUID } = this.props;
    const uuidChanged = prevUUID !== uuid;
    const modelUUIDChanged = prevModelUUID !== modelUUID;
    if (uuidChanged || modelUUIDChanged) {
      if (this._overlayScroll) {
        this._overlayScroll.scrollTop = 0;
      }
    }
  }

  componentWillUnmount() {
    unfixBody();
  }

  hideOffContentClick(evt) {
    if (evt.target.classList.contains(OFF_OVERLAY_CLASS)) {
      const ctxHideOverlay = this.props.hideOverlay || hideOverlay;
      ctxHideOverlay(this.props.router);
    }
  }

  render() {
    const { children, customClasses } = this.props;
    const classes = { ...DEFAULT_CLASSES, ...customClasses };
    const ctxHideOverlay = this.props.hideOverlay || hideOverlay;
    const iconProps = {
      iconType: "close",
      iconProps: {
        size: 24
      },
      colors: {
        inactive: COLORS.primary
      },
      onClick: () => ctxHideOverlay(this.props.router)
    };

    return (
      <div
        className={classes.container}
        style={{ backgroundColor: "rgba(67, 90, 111, 0.7)" }}
        onClick={this.hideOffContentClick}
      >
        <div className={classes.overlay}>
          <div
            style={OVERFLOW_TOUCH}
            ref={(overlayScroll) => {
              this._overlayScroll = overlayScroll;
            }}
            className={classes.content}
          >
            <div style={{ top: 8, right: 8 }} className={classes.action}>
              <IconButton {...iconProps} />
            </div>
            {children}
            <Padder theme="visible" />
            <style jsx>{`
              @media (min-width: ${PHONE + 1}px) {
                .contentSection {
                  border-left-style: solid;
                }
              }
            `}</style>
          </div>
        </div>
      </div>
    );
  }
}

Overlay.propTypes = {
  overlayClick: PropTypes.func,
  buttonClick: PropTypes.func
};

export default withRouter(Overlay);
